import React, { useState } from "react";
import {
    Typography,
    Box,
    Stack,
    Link,
    Paper,
    IconButton,
    ButtonBase,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
// import { _apiUrls } from "@/utils/endPoints/apiUrls";
// import { handleCopy } from "@/utils/helpers/appHelpers";
// import { _orderDetailStatus, _paymentStatus, _paymentType } from "@/utils/constants/constants";

// import { _routes } from "@/utils/endPoints/routes";
import { handleCopy } from "../../utils/helper/appHelpers";


export default function CustomerInfo({ orderInfo, showBillingAddress = true }) {

    const [editContact, setEditContact] = useState(false);

    // Helper functions
    const handleContactOpen = () => setEditContact(true);

    // Formatted Address String
    const getFormatedStr = () => {
        const text = []
        if (orderInfo?.orderDetails?.[0]?.dropLocation?.type) {
            text.push(orderInfo?.orderDetails?.[0]?.dropLocation?.type);
        }
        if (orderInfo?.orderDetails?.[0]?.dropLocation?.apartment) {
            text.push(`Apt: ${orderInfo?.orderDetails?.[0]?.dropLocation?.apartment}`)
        }

        return text.join("-");
    }

    // UI/UX
    return (
        <>
            <Paper elevation={1} sx={{ p: 2, borderRadius: 1, }}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    Customer
                </Typography>

                <Typography component={"p"} variant="body2" color="#138118" sx={{ mb: 1 }}>
                    {orderInfo?.userInfo?.userName}
                </Typography>

                <Stack direction={"row"} alignItems="center" mb={1} justifyContent={"space-between"}>
                    <Typography variant="subtitle2">
                        Contact information
                    </Typography>
                </Stack>

                <Box display="flex" alignItems="center" mb={1} justifyContent={"space-between"}>
                    <ButtonBase sx={{ color: "#138118" }} onClick={handleContactOpen}>
                        <Typography variant="subtitle3"> {orderInfo?.userInfo?.email}</Typography>
                    </ButtonBase>
                    <IconButton size="small" onClick={() => handleCopy({ message: 'Email', text: `${orderInfo?.userInfo?.email}` })}>
                        <ContentCopyIcon sx={{ fontSize: 15 }} />
                    </IconButton>
                </Box>
                <Box display="flex" alignItems="center" mb={2} justifyContent={"space-between"}>
                    <ButtonBase color="#138118" sx={{ color: "#138118" }}>
                        <Typography variant="subtitle3">{orderInfo?.userInfo?.dialCode} {orderInfo?.userInfo?.mobileNo}</Typography>
                    </ButtonBase>
                    <IconButton size="small" onClick={() => handleCopy({ message: 'Phone', text: `${orderInfo?.userInfo?.dialCode} ${orderInfo?.userInfo?.phone}` })}>
                        <ContentCopyIcon sx={{ fontSize: 15 }} />
                    </IconButton>
                </Box>

                <Stack direction={"row"} alignItems="center" justifyContent={"space-between"}>
                    <Typography variant="subtitle2">
                        Delivery address
                    </Typography>
                </Stack>

                <Typography sx={{ lineHeight: 2.5 }} variant="body2" color="text.secondary">
                    {`${getFormatedStr()} ${orderInfo?.deliveryAddress?.addressLine1}`}
                    <br />
                    {`${orderInfo?.deliveryAddress?.city} ${orderInfo?.deliveryAddress?.state} ${orderInfo?.deliveryAddress?.pincode} ${orderInfo?.deliveryAddress?.country || ''}`}
                </Typography>

                <Box mt={2}>
                    <Typography variant="subtitle2" gutterBottom>
                        Pickup address
                    </Typography>
                    <Typography sx={{ lineHeight: 2.5 }} variant="body2" color="text.secondary">
                        {`${getFormatedStr()} ${orderInfo?.pickupAddress?.addressLine1}`}
                        <br />
                        {`${orderInfo?.pickupAddress?.city} ${orderInfo?.pickupAddress?.state} ${orderInfo?.pickupAddress?.pincode} ${orderInfo?.pickupAddress?.country || ''}`}
                    </Typography>
                </Box>
            </Paper>
        </>
    )
}
